export var GastronomyLaborRoutes = {
    '/gastronomy-labor': {
        'loginRequired': true,
        'name': 'appLayout.schedule.gastronomy-labor',
        "showGlobalSearch": true,
        'type': 'frontend',
        'views': {
            'body': {
                'component': 'gastronomyLaborWeeksListContainer'
            }
        },
        'route_styles': {
            framework: 'bootstrap_v4',
            styles: ['gastronomy-labor', 'abs-generation']
        },
        'route_dependencies': [
            {
                type: 'chunk',
                loader: function () {
                    return import("./../activity-based-scheduling-generation/activity-based-scheduling-generation.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('./gastronomy-labor.module.js');
                }
            }
        ],
        'onEnter': ['userServices', '$state', 'TeamScheduleService', 'hUser',
            function (userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        userServices.isServiceEnabled(userServices.SERVICES.GASTRONOMY_LABOR_MODEL, brand.id)
                            .then(function (isGastronomyLaborServiceEnabled) {
                                if (!isGastronomyLaborServiceEnabled || !hUser.hasSalesAccess()) {
                                    $state.go('appLayout.schedule.main');
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    },
    "/gastronomy-labor-projections?date": {
        "loginRequired": true,
        "name": "appLayout.schedule.gastronomy-labor-projections",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "gastronomyLaborProjectionContainer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./../activity-based-scheduling-generation/activity-based-scheduling-generation.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./../../activity-based-scheduling/activity-based-scheduling.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./gastronomy-labor.module.js");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["gastronomy-labor", "abs-generation"]
        },
        "onEnter": ['userServices', '$state', 'TeamScheduleService', 'hUser',
            function (userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        userServices.isServiceEnabled(userServices.SERVICES.GASTRONOMY_LABOR_MODEL, brand.id)
                            .then(function (isGastronomyLaborServiceEnabled) {
                                if (!isGastronomyLaborServiceEnabled || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    }
};